module.exports = __webpack_public_path__ + "bbbc7b28ef9fc0eadc58908bfe827b9e.pdf";